import { CommonModule } from '@angular/common';
import { ConfigModule } from 'NewAngular/config/config.module';
import { CascadingDropdownModule } from 'NewAngular/features/components/dropdowns/cascading-dropdown/cascading-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { HoldingsAllHoldingsDatePickerModule } from 'SecuritiesApp/ts/features/holdings-all-holdings-date-picker/holdings-all-holdings-date-picker.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class HoldingsAllHoldingsModule {
}
HoldingsAllHoldingsModule.ɵfac = function HoldingsAllHoldingsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsAllHoldingsModule)(); };
HoldingsAllHoldingsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsAllHoldingsModule });
HoldingsAllHoldingsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        HoldingsAllHoldingsDatePickerModule,
        IconModule,
        DisabledModule,
        CascadingDropdownModule,
        HelpModalModule,
        LoadingSymbolModule,
        ModalBaseModule,
        ModuleUpsellModule] });
